import React from 'react'
import { IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { PlayArrow } from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import { activeModal } from '../actions'

const PlayButton = styled(IconButton)({
  position: 'absolute',
  left: '50%',
  top: '50%',
  backgroundColor: '#0008',
  transform: 'translate(-50%, -50%)',
  transition: 'all .3s ease',
  '&:hover': {
    backgroundColor: '#000b'
  }
})

interface IVideoURL {
  videoURL: string
}

export default function VideoModalPlayButton(props: IVideoURL) {
  const dispatch = useDispatch()

  return (
    <PlayButton
      size='large'
      sx={{ color: '#fff' }}
      onClick={() => {
        dispatch(activeModal(props.videoURL))
      }}
      data-cy='video-modal-play-button'
    >
      <PlayArrow sx={{ width: { xs: 40, sm: 60, md: 80 }, height: { xs: 40, sm: 60, md: 80 } }} />
    </PlayButton>
  )
}
